<template>
  <div id="layout">
    <div id="protrol">
    <p class="p" align="center" style="margin-top:0.0000pt;margin-left:0.0000pt;text-indent:0.0000pt;
mso-pagination:widow-orphan;text-align:center;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 15pt; font-family: 宋体;">江南药镇商城用户服务协议</span>
        </b>
        <span style="letter-spacing: 0pt; font-size: 10.5pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin-top: 0pt; margin-left: 0pt; text-indent: 0pt;">
        <span style="letter-spacing: 0pt; font-size: 10.5pt; font-family: 宋体;">&nbsp;</span>
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">&nbsp;欢迎阅读金华鑫扬网络科技有限公司《江南药镇商城》服务条款协议(下称“本协议”)。本协议阐述之条款和条件适用于您使用《江南药镇商城》网站（www.jnyzpa.com）所提供的，在互联网上进行贸易和交流的各种工具和服务(下称“服务”)。本协议在《江南药镇商城》用户接受注册时生效。</span>
        <span style="letter-spacing: 0pt; font-size: 12pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin-top: 0pt; margin-left: 0pt; text-indent: 24pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">您在成为《江南药镇商城》用户前，必须仔细阅读并接受本协议中所述的所有规则、条款和条件，包括因被提及而纳入的条款和条件。</span>
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">强烈建议您阅读本协议时，同时阅读本协议中提及的其他网页、附件所包含的内容，因为其可能包含对作为《江南药镇商城》用户的您适用的进一步条款和条件</span>
        </b>
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">，</span>
        </b>
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">尤其是协议中黑色加粗的条款。</span>
        </b>
        <span style="letter-spacing: 0pt; font-size: 12pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin-top: 0pt; margin-left: 0pt; text-indent: 0pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">一、用户注册：</span>
        </b>
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.用户注册是指用户登录《江南药镇商城》网站，按要求填写相关信息并确认同意履行相关用户协议的过程。用户因进行交易、获取有偿服务等而发生的所有应纳税赋由用户自行承担。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.本协议所指用户分为个人用户与企业用户：</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.1 个人用户（买家）是指通过《江南药镇商城》向企业用户购买药品、医疗器械、保健食品、化妆品等商品的具有完全民事行为能力的自然人；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.2 企业用户（卖家）是指通过《江南药镇商城》向个人用户以零售等方式从事药品、医疗器械、保健品、化妆品销售的药店、医药公司及生产企业且必须是具有合法经营资格和相关经营许可的法人组织；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.3 限制民事行为能力与无民事行为能力的自然人、无经营或特定经营资格的组织不当注册为《江南药镇商城》用户进行交易的，其与《江南药镇商城》之间的服务协议自始无效，一经发现，《江南药镇商城》有权立即停止与该用户的交易、注销该用户，并追究其使用《江南药镇商城》“服务”的一切法律责任。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">3.用户在此保证所填写的用户信息是真实、准确、完整、及时的，并且没有任何引人误解或者虚假的陈述，且保证《江南药镇商城》可以通过用户所填写的联系方式与用户取得联系。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">4.用户应根据《江南药镇商城》对于相关服务的要求及时提供相应的身份证明等资料，否则《江南药镇商城》有权拒绝向该会员或用户提供相关服务。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">5.用户承诺将及时更新其用户信息以维持该等信息的有效性。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.如果用户提供的资料或信息包含有不正确、不真实的信息，《江南药镇商城》保留取消用户会员资格并随时结束为该用户提供服务的权利。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">7.用户注册成功后将得到一个用户名和密码，用户凭用户名和密码享受《江南药镇商城》向其会员用户提供的商品和服务。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">8.用户将对用户名和密码安全负全部责任，并且用户对以其用户名进行的所有活动和事件负全责。用户有权根据《江南药镇商城》规定的程序修改密码。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">9.非经《江南药镇商城》书面同意，用户名和密码不得擅自转让或者授权他人使用，否则用户应承担由此造成的一切后果。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">10.用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通告《江南药镇商城》。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">二、商品交易与平台服务：</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.用户在《江南药镇商城》交易商品时必须遵守以下条款：</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.用户在使用《江南药镇商城》服务时应遵守所有适用的中国法律、法规、条例和地方性法律的要求。用户还必须确保遵守本协议及纳入本协议的所有其他条款和规则的规定。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">3.《江南药镇商城》作为一家专业的第三方互联网交易服务电子商务平台，有义务向买卖双方提供第三方互联网交易服务的技术支持和日常维护；为卖家提供网店展示界面和在线交易系统，用于宣传和商品展示及即时交易，为个性化网店定制提供技术支持；为卖家其指定的医药进销存管理软件(ERP)与网站数据库系统之间的数据对接提供技术支持服务；免费提供专用的在线客服聊天系统满足买卖双方的在线咨询；配备专职客服专员提供技术支持服务，服务时间为工作日9:00～18:00；协助买卖双方解决交易纠纷及处理投诉事务。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">4.用户通过《江南药镇商城》网站订购商品，订单即为购买商品的申请或要约。但只有当卖家向用户发出确认收到订单及送货确认内容的电子数据，才构成卖家对该订单的承诺，此时合同即告成立。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">5.卖家有权在发现《江南药镇商城》网站上显示的商品及订单明显错误或缺货的情况下，单方面撤回这些信息或撤销该订单。卖家保留对产品订购数量的限制权。</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.商品价格和可获性都将在《江南药镇商城》网站上标明，显示的每一项价格都包含了增值税（按照法定税率）。送货费将另行计算</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">7.在已确认用户订单后如发生意外的情况，包括但不限于由于供应商提价，税额变化引起的价格变化，或是由于网站的错误等造成价格变化等情况，卖家在及时通知用户后有权取消该订单。在卖家取消该订单之前，用户亦有权决定是否取消订单。</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">三、用户的权利和义务：</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.用户有权拥有其在《江南药镇商城》的用户名及密码，并随时登录《江南药镇商城》网站，同时用户可以使用用户信息通过《江南药镇商城》进行交易行为。但不得以任何形式转让或授权他人使用自己的《江南药镇商城》用户名。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.用户有权根据本协议的规定以及《江南药镇商城》网站上发布的相关规则在《江南药镇商城》网站上查询商品信息、发表使用体验、参与商品讨论、邀请关注好友、上传商品图片、参加《江南药镇商城》的有关活动，以及享受《江南药镇商城》提供的其它信息服务。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">3.用户有义务在注册和交易时提供自己的真实资料，并保证诸如电子邮件地址、联系电话、联系地址、邮政编码等内容的有效性及安全性，保证买卖双方可以通过上述联系方式进行联系。同时，用户也有义务在相关资料实际变更时及时更新有关注册资料。用户保证不以他人资料在《江南药镇商城》进行注册和交易行为。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">4.用户应当保证在使用《江南药镇商城》买卖商品过程中遵守诚实信用原则，不在交易过程中采取不正当行为，不扰乱网上交易的正常秩序。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">5.用户享有言论自由权利；并拥有适度修改、删除自己发表的文章的权利。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.用户保证其使用《江南药镇商城》服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用《江南药镇商城》提供的服务进行存储、发布、传播如下信息和内容：</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.1违反国家法律、法规政策的任何内容（信息）；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.2违反国家规定的政治宣传和/或新闻信息；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.3涉及国家秘密和/或安全的信息；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.4封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.5博彩有奖、赌博游戏；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.6违反国家民族和宗教政策的信息；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.7妨碍互联网运行安全的信息；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.8侵害他人合法权益的信息和/或其他有损于社会秩序、社会治安、公共道德的信息或内容。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">7.用户同时承诺不得为他人发布上述不符合国家规定和/或本服务条款约定的信息内容提供任何便利，包括但不限于设置URL、BANNER链接等。用户承认《江南药镇商城》有权在用户违反上述时有权终止向用户提供服务并不于退还任何款项，因用户上述行为给《江南药镇商城》造成损失的，用户应予赔偿。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">8.用户在发表使用体验、讨论图片等，除遵守本条款外，还应遵守该讨论区的相关规定。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">9.未经《江南药镇商城》同意，禁止用户在网站发布任何形式的广告。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">10.用户可通过《江南药镇商城》对订单进行评价，包括但不限于客服服务、发货速度、物流速度、商品包装等评价，该评价仅代表用户的满意度评价，不作为商品使用效果的依据。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">四、《江南药镇商城》的权利和义务：</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.《江南药镇商城》应根据用户选择的服务以及交纳款项的情况向用户提供合格的网络技术和信息服务。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.《江南药镇商城》承诺对用户资料采取对外保密措施，不向第三方披露用户资料，不授权第三方使用用户资料，除非：</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.1依据本协议条款或者用户与《江南药镇商城》之间其他服务协议、合同、在线条款等规定可以提供；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.2依据法律、法规的规定应当提供；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.3行政、司法等有权部门要求《江南药镇商城》提供；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.4用户同意《江南药镇商城》向第三方提供；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.5《江南药镇商城》解决举报事件、提起诉讼而提交的；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.6《江南药镇商城》为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.7《江南药镇商城》为向用户提供产品、服务、信息而向第三方提供的，包括《江南药镇商城》通过第三方的技术及服务向用户提供产品、服务、信息的情况。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">3.《江南药镇商城》有权使用用户资料。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">4.《江南药镇商城》有权利对用户进行审查并决定是否接受用户成为《江南药镇商城》经营企业会员或是否与用户进行某一交易。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">5.《江南药镇商城》保留在用户违反国家、地方法律、法规规定或违反本在线注册条款的情况下终止为用户提供服务并终止用户账号的权利，并且在任何情况下，《江南药镇商城》对任何间接、偶然、特殊及继起的损害不负责任。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">五、违约责任：</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.如果商家因为定价错误、商品缺货、商品描述错误给消费者带来不便，商家应立即对上述情况进行调整修改并向消费者致歉。</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.用户存在下列行为的，视为违约，《江南药镇商城》有权做出相应处理：</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.1《江南药镇商城》有权对用户的注册数据及交易行为进行查阅，发现注册数据或交易行为中存在任何问题或怀疑，均有权向用户发出询问及要求改正的通知或者直接作出删除等处理；</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.2经国家生效法律文书或行政处罚决定确认用户存在违法行为，或者《江南药镇商城》有足够事实依据可以认定用户存在违法或违反服务协议行为的，《江南药镇商城》有权在网站上以网络发布形式公布用户的违法行为；</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.3对于用户在《江南药镇商城》发布的下列各类信息，《江南药镇商城》有权在不通知用户的前提下进行删除或采取其它限制性措施。包括以炒作信用为目的的信息；《江南药镇商城》有理由相信存在欺诈等恶意或虚假内容的信息；《江南药镇商城》有理由相信存在与网上交易无关或不是以交易为目的的信息；《江南药镇商城》有理由相信存在试图扰乱正常交易秩序因素的信息；《江南药镇商城》有理由相信该信息违反公共利益或可能严重损害《江南药镇商城》和其它用户合法利益的。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">六、风险承担与规则：</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.如果买家有证据证明因卖家产品信息的真实性使买家利益受到损失，卖家将对此承担责任；如果是由于买家的错误理解导致利益受到损失，卖家将不承担责任。《江南药镇商城》作为第三方有义务对双方的纠纷进行积极的协调，并根据调查结果对用户进行相应的处理。</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.如果交易产品质量存在问题，给买家利益造成损失，卖家将按照退换货规则承担责任。</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">3.交易达成后，在产品的配送过程中，产品出现毁损、灭失的，与买家无关。</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">4.网络安全问题导致买家利益受到损失，《江南药镇商城》不承担损失赔偿责任，但有义务配合买家进行查询沟通。</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">5.除上述风险承担条款以外，具体的送货、退换货、补货及质量纠纷处理规则等《江南药镇商城》将另行公布。</span>
        </b>
        <b>
            <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
                <o:p></o:p>
            </span>
        </b>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">6.责任限制</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">除了《江南药镇商城》的使用规则中规定的其它限制和除外情况之外，在中国法律法规所允许的限度内，对于因平台运营而引起的或与之有关的任何直接的、间接的、特殊的、附带的、后果性的或惩罚性的损害，或任何其它性质的损害，《江南药镇商城》、《江南药镇商城》的董事、管理人员、雇员、代理或其它代表在任何情况下都不承担责任。不论是合同、保证、侵权（包括过失）项下的还是任何其它的责任，均为买卖双方因交易而引起的纠纷，与第三方平台《江南药镇商城》无关。这些责任排除和限制条款将在法律所允许的最大限度内适用，并在用户资格被撤销或终止后仍继续有效。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">七、服务的中断和终止：</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.如用户向《江南药镇商城》提出注销注册用户身份时，经《江南药镇商城》审核同意，由《江南药镇商城》注销该注册用户，用户即解除与《江南药镇商城》的服务协议关系。但注销该用户账号后，《江南药镇商城》仍保留下列权利：</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.1用户注销后，《江南药镇商城》有权保留该用户的注册数据及以前的交易行为记录；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.2用户注销后，如用户在注销前在《江南药镇商城》交易平台上存在违法行为或违反合同的行为，《江南药镇商城》仍可行使本服务协议所规定的权利。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.在下列情况下，《江南药镇商城》可以通过注销用户的方式终止服务：</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.1在用户违反本服务协议相关规定时，《江南药镇商城》有权终止向该用户提供服务。《江南药镇商城》将在中断服务时通知用户。但如该用户在《江南药镇商城》终止提供服务后，再一次直接或间接或以他人名义注册为《江南药镇商城》用户的，《江南药镇商城》有权再次单方面终止向该用户提供服务；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.2如《江南药镇商城》通过用户提供的信息与用户联系时，发现用户在注册时填写的电子邮箱已不存在或无法接收电子邮件的，经《江南药镇商城》以其它联系方式通知用户更改，而用户在三个工作日内仍未能提供新的电子邮箱地址的，《江南药镇商城》有权终止向该用户提供服务；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.3一经《江南药镇商城》发现用户注册数据中主要内容是虚假的，《江南药镇商城》有权随时终止向该用户提供服务；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.4本服务协议终止或更新时，用户明示不愿接受新的服务协议的；</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.5其它《江南药镇商城》认为需终止服务的情况。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">八、适用的法律和管辖权：</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">用户和《江南药镇商城》之间的服务协议将适用中华人民共和国的法律，管辖地为金华市婺城区人民法院。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">九、知识产权：</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.《江南药镇商城》网站上的图表、标识、网页页眉、按钮图标、文字、服务品名等标示在网站上的信息都是金华鑫扬网络科技有限公司的财产，受中国和国际知识产权法的保护。未经《江南药镇商城》许可，用户不得以任何可能引起消费者混淆的方式或任何贬低或诽谤金华鑫扬网络科技有限公司的方式用于与非《江南药镇商城》的任何产品或服务上。在《江南药镇商城》网站上出现的不属于上述主体的所有其他商标是其商标权利人各自的财产，这些权利人可能是也可能不是与金华鑫扬网络科技有限公司相关联、相联系或由金华鑫扬网络科技有限公司的关联公司赞助的。未经金华鑫扬网络科技有限公司或相关商标所有人的书面许可，《江南药镇商城》网站上的任何东西都不应被解释为以默许或其他方式授予许可或使用网站上出现的商标的权利。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.《江南药镇商城》用户发表的文章仅代表作者本人观点，与《江南药镇商城》立场无关。作者文责自负。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">3.《江南药镇商城》有权将在本网站发表的产品使用体验、产品讨论或图片自行使用或者与其他人合作使用于其他用途，包括但不限于网站、电子杂志、杂志、刊物等，使用时需为作者署名，以发表文章时注明的署名为准。文章有附带版权声明者除外。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">4.用户在《江南药镇商城》网站上发表的文章及图片（包括转贴的文章及图片）版权仅归原作者所有，若作者有版权声明或原作从其它网站转载而附带有原版权声明者，其版权归属以附带声明为准。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">&nbsp;</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">5.任何转载、引用发表于《江南药镇商城》的版权文章须符合以下规范：</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">5.1用于非商业、非盈利、非广告性目的时需注明作者及文章及图片的出处为"《江南药镇商城》"或“www.jnyzpa.com”。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">5.2用于商业、盈利、广告性目的时需征得文章或图片原作者的同意，并注明作者姓名、授权范围及原作出处"《江南药镇商城》"或“www.jnyzpa.com”。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">5.3任何文章或图片的修改或删除均应保持作者原意并征求原作者同意，并注明授权范围。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">十、不承诺担保和责任限制</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.除非另有明确的书面说明，《江南药镇商城》网站、目录及其所包含的或以其它方式通过本网站提供给用户的全部信息、内容、材料、商品（包括软件）和服务，是由金华鑫扬网络科技有限公司在"按现状"和"按现有"的基础上提供的。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.除非另有明确的书面说明,金华鑫扬网络科技有限公司不对本网站的运营及其包含在本网站上的信息、内容、材料、产品(包括软件)或服务作任何形式的、明示或默示的声明或担保（除根据中华人民共和国法律规定的以外）。用户明确同意自担风险使用本网站。 在适用法律所允许的最大限度内，金华鑫扬网络科技有限公司及其关联公司不承诺所有明示或默示的担保，包括但不限于对适销性和满足特定目的的默示担保。金华鑫扬网络科技有限公司及其关联公司不担保《江南药镇商城》网站、其所包含的或以其它方式通过本网站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从《江南药镇商城》网站发出的电子信件没有病毒或其他有害成分。除非另有明确的书面说明，金华鑫扬网络科技有限公司不对由于使用《江南药镇商城》网站、或由于其所包含的或以其它方式通过本网站提供给用户的全部信息、内容、材料、产品（包括软件）和服务、或购买和使用产品引起的任何损害承担责任（除非根据中华人民共和国法律应承担责任的以外），包括但不限于直接、间接或附带的惩罚性和结果性的损害赔偿。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">十一、隐私：</span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt;">
            <font face="宋体">
                <span style="font-family: 宋体;">用户使用我们的服务时</span>
            </font>
            <font face="宋体">
                <span style="font-family: 宋体;">,我们如何收集使用、存储、共享和保护用户的隐私信息，以及我们为用户提供的查阅、更正、复制、删除这些信息的方式，参见《江南药镇商城隐私保护政策》。</span>
            </font>
        </span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 0pt; padding: 0pt; line-height: 20pt;">
        <b>
            <span style="letter-spacing: 0pt; font-size: 12pt;">
                <font face="宋体">
                    <span style="font-family: 宋体;">十二条</span>
                </font>
                <font face="宋体">
                    <span style="font-family: 宋体;">&nbsp;附则：</span>
                </font>
            </span>
        </b>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">1.本注册条款中有关条款若被权威机构认定为无效，不应影响其他条款的效力，也不影响本服务条款的解释、违约责任及争议解决的有关约定的效力。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">2.一方变更通知、通讯地址或其他联系方式，应自变更之日起及时将变更后的地址、联系方式通知另一方，否则变更方应对此造成的一切后果承担责任。用户同意，《江南药镇商城》的有关通知只需在《江南药镇商城》有关网页上发布即视为送达用户。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">3.因《江南药镇商城》上市、被收购、与第三方合并、名称变更等事由，用户同意《江南药镇商城》可以将其权利和/或义务转让给相应的《江南药镇商城》权利/义务的承受者。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
    <p class="p" style="margin: 7.85pt 0pt 0pt; text-indent: 21pt; padding: 0pt; line-height: 20pt;">
        <span style="letter-spacing: 0pt; font-size: 12pt; font-family: 宋体;">用户在此再次保证已经完全阅读并理解了上述会员注册条款并自愿正式进入《江南药镇商城》入驻会员在线注册程序，接受上述所有条款的约束。</span>
        <span style="font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 0pt; font-size: 9pt;">
            <o:p></o:p>
        </span>
    </p>
</div>
  </div>
</template>

<script>

export default {
    name:"Layout",
    components:{
    },
    created(){
        
    },
    mounted(){

    }
}
</script>

<style scoped>
    .main_view{
        min-height: calc(100vh - 62px - 206px - 40px);
    }
</style>